export default __webpack_public_path__ + "static/media/048-abkhazia.af433f69.svg";